/*
 * App Styles for JS
 */

export const COLORS = {
  error: "#d0021b"
};
